import React from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import MarkdownContent from './MarkdownContent';
import styles from '../styles/TopicTabs.module.css';

const TopicTabs = ({ tabs, label, contentClassName }) => {
  const history = useHistory();
  const location = useLocation();
  const hashId = location.hash.replace(/^#/, '');
  const activeTab = tabs.find(tab => tab.slug === hashId || tab.id === hashId) || tabs[0];

  if (!activeTab) return null;

  return (
    <div className={styles.layout}>
      <nav className={styles.tabs} aria-label={label}>
        {tabs.map(tab => (
          <button
            className={`${styles.tab} ${tab.id === activeTab.id ? styles.active : ''}`}
            key={tab.id}
            type="button"
            aria-selected={tab.id === activeTab.id}
            role="tab"
            onClick={() => {
              const tabSlug = tab.slug || tab.id;
              history.push(`${location.pathname}${location.search}#${tabSlug}`);
            }}
          >
            {tab.label}
          </button>
        ))}
      </nav>

      <div className={styles.panel} role="tabpanel">
        <MarkdownContent src={activeTab.src} className={contentClassName} />
      </div>
    </div>
  );
};

TopicTabs.defaultProps = {
  tabs: [],
  label: 'Topics',
  contentClassName: '',
};

export default TopicTabs;
